import type { LocalizedString, LocalizedStringArray } from '../../types';
import { Locale } from '../../types';

/** Shared localized-field helpers for the admin forms */

export const EMPTY_LOCALIZED: LocalizedString = { ru: '', en: '', kz: '' };

/** pros/cons are edited as one-item-per-line textareas per locale */
export const lines_to_array = (value: LocalizedString): LocalizedStringArray | null => {
  const split = (text: string): string[] =>
    text.split('\n').map((line) => line.trim()).filter(Boolean);

  const result: LocalizedStringArray = {
    [Locale.ru]: split(value.ru),
    [Locale.en]: split(value.en),
    [Locale.kz]: split(value.kz),
  };

  const has_items = result.ru.length || result.en.length || result.kz.length;
  return has_items ? result : null;
};

export const array_to_lines = (value?: LocalizedStringArray): LocalizedString => ({
  ru: value?.ru?.join('\n') ?? '',
  en: value?.en?.join('\n') ?? '',
  kz: value?.kz?.join('\n') ?? '',
});
